import { render, staticRenderFns } from "./opcr-view.vue?vue&type=template&id=0ea09005&"
import script from "./opcr-view.vue?vue&type=script&lang=js&"
export * from "./opcr-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports